import { z } from 'zod'

export const schema = z.object({
  cottagePhones: z.array(
    z.object({
      prefix: z.string(),
      phoneNumber: z.string(),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>
